import React from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import './HeroCarousel.css';

const homeSlides = [
  {
    image: '/img/slider1.jpg',
    title: 'SSVASS Jewellery Mahotsav 2026',
    subtitle: '21st Edition | 30 Aug to 01 Sep 2026 | Gyan Bhawan, Gandhi Maidan, Patna',
  },
  {
    image: '/img/slider2.jpg',
    title: 'SSVASS Jewellery Mahotsav 2026',
    subtitle: '21st Edition | 30 Aug to 01 Sep 2026 | Gyan Bhawan, Gandhi Maidan, Patna',
  },
  {
    image: '/img/slider3.jpg',
    title: 'SSVASS Jewellery Mahotsav 2026',
    subtitle: '21st Edition | 30 Aug to 01 Sep 2026 | Gyan Bhawan, Gandhi Maidan, Patna',
  },
  {
    image: '/img/slider4.jpg',
    title: 'SSVASS Jewellery Mahotsav 2026',
    subtitle: '21st Edition | 30 Aug to 01 Sep 2026 | Gyan Bhawan, Gandhi Maidan, Patna',
  }
];

const HeroCarousel = () => {
  const sliderSettings = {
    autoplay: true,
    autoplaySpeed: 3000,
    speed: 1500,
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: true,
    infinite: true,
    arrows: false,
    fade: true
  };

  return (
    <div className="carousel">
      <Slider {...sliderSettings}>
        {homeSlides.map((img, index) => (
          <div key={index} className="carousel-item">
            <div className={`carousel-img ${!img.image ? 'carousel-img-fallback' : ''}`}>
              {img.image && (
                <img
                  src={img.image}
                  alt={img.title || `Slide ${index + 1}`}
                  onError={(event) => {
                    event.currentTarget.style.display = 'none';
                    event.currentTarget.parentElement.classList.add('carousel-img-fallback');
                  }}
                />
              )}
              {(img.title || img.subtitle) && (
                <div className="carousel-caption">
                  <span>National Gems & Jewellery Exhibition</span>
                  {img.title && <h2>{img.title}</h2>}
                  {img.subtitle && <p>{img.subtitle}</p>}
                </div>
              )}
            </div>
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default HeroCarousel;
